module.exports = __webpack_public_path__ + "media/Blob 1 Joins.6bab9468.mp3";